export const environment = {
  SERVER_ORIGIN: '',
  production: false,
  // urlBase: 'http://10.1.37.24:9686',
  urlLogin: 'http://10.1.37.24:9800',
  urlSystem: 'http://10.1.37.24:9801',
  urlScheduler: 'http://10.1.37.24:9808',
  timeOut: 30000,
  isMockData: true,
  // config
  urlPdfDownload: 'https://www.mbcambodia.com/en/promotion/download-mbcambodia-my-bank-app-to-get-2-reward',
  timeActiveReferral: 'From 01/02/2024',
  urlOpenStoreAndroid: 'https://play.google.com/store/apps/details?id=com.mbbank.cam&referrer=com.mbbank.cam://',
  // urlOpenStoreIos: 'itms-apps://itunes.apple.com/app/id1569327822',
  urlOpenStoreIos: 'https://itunes.apple.com/app/id1569327822',
  urlOpenAppAndroid: 'com.mbbank.cam://',
  urlOpenAppIos: 'com.mbbank.cam://',
  startIntentChrome: 'intent://',
  endIntentChrome: '#Intent;scheme=com.mbbank.cam;package=com.mbbank.cam;end',
  // new
  key: 'AIzaSyDrbmvaRhw3oGWvlM-GSdqdeHEMmmaCtSs',
  pageLink: "https://mbcmybank.page.link",
  linkApp: "https://campaign.mbcambodia.com/?code=PARAM_CODE",
  linkAPN: "com.mbbank.cam",
  linkAFL: "https://play.google.com/store/apps/details?id=com.mbbank.cam&referrer=https://mbcambodia.com/app/?code=PARAM_CODE",
  linkIBI: "com.mbbank.cam",
  // linkIFL: "https://itunes.apple.com/app/id1569327822",
  codeISI: "1569327822",
  // linkIUS: "com.mbbank.cam://campaign.mbcambodia.com/mobilebanking-referral/?code=PARAM_CODE",
  linkOFL: "https://campaign.mbcambodia.com/mobilebanking-referral/?code=PARAM_CODE",
  linkST: "",
  paramST: "&st=LINK_ST",
  linkSD: "",
  paramSD: "&sd=LINK_SD",
  linkSI: "",
  paramSI: "&si=LINK_SI",
  // urlFireBase: "PAGE_LINK/?link=LINK_APP&apn=LINK_APN&afl=LINK_AFL&ibi=LINK_IBI&ifl=LINK_IFL&isi=CODE_ISI&ius=LINK_IUS&ofl=LINK_OFL",
  urlFireBase: "PAGE_LINK/?link=LINK_APP&apn=LINK_APN&afl=LINK_AFL&ibi=LINK_IBI&isi=CODE_ISI&ofl=LINK_OFL",
  apiFireBaseHost: 'https://firebasedynamiclinks.googleapis.com',
  apiFireBasePath: 'v1/shortLinks'
};
